import {
  adminClient,
  magicLinkClient,
  oneTapClient,
} from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { API_BASE_URL } from '@/common/config/runtime.ts';

export const authClient = createAuthClient({
  baseURL: API_BASE_URL,
  plugins: [
    adminClient({}),
    magicLinkClient(),
    oneTapClient({
      clientId:
        '769010990191-kik0gucaja327uem42pjrhuga31mvl34.apps.googleusercontent.com',
      autoSelect: false,
      cancelOnTapOutside: true,
      context: 'signin',
    }),
  ],
});

export type PossibleUserWithRole = { role?: string | null } | null | undefined;

export function userHasRole(user: PossibleUserWithRole, role: string): boolean {
  return user?.role === role;
}
